<!-- 
Status indicators for whether a provider contact is synchronised with HITS, or is manually created and not synchronised.
-->
<template>
  <span>
    <v-icon v-if="isSyncronised(contact)">
      sync
    </v-icon>
    <v-icon v-if="!isSyncronised(contact)">
      sync_disabled
    </v-icon>
  </span>
</template>

<script>
export default {
  props: {
    contact: {
      type: Object,
      required: true
    }
  },
  computed: {},
  methods: {
    isSyncronised(contact) {
      return contact.synchroniseWithHits;
    }
  }
};
</script>
